module.exports = __webpack_public_path__ + "static/media/count25Off_118.06e071db.png";